import { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../supabaseClient'

export default function EditPost() {
  const { id } = useParams()
  const navigate = useNavigate()

  const [title, setTitle] = useState('')
  const [content, setContent] = useState('')
  const [imageUrl, setImageUrl] = useState('')
  const [newImageFile, setNewImageFile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(false)
  const [uploading, setUploading] = useState(false)
  const [timeLeft, setTimeLeft] = useState(null) // seconds left during upload

  useEffect(() => {
    async function fetchPost() {
      const { data, error } = await supabase
        .from('posts')
        .select('title, content, image_url')
        .eq('id', id)
        .single()

      if (error) {
        alert('Failed to load post')
        navigate(-1)
        return
      }

      setTitle(data.title)
      setContent(data.content)
      setImageUrl(data.image_url || '')
      setLoading(false)
    }
    fetchPost()
  }, [id, navigate])

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    if (file) {
      setNewImageFile(file)
      setImageUrl(URL.createObjectURL(file))
    }
  }

  const handleSave = async () => {
    if (!title.trim() || !content.trim()) {
      alert('Title and content are required.')
      return
    }

    setSaving(true)

    let updatedImageUrl = imageUrl

    if (newImageFile) {
      setUploading(true)
      setTimeLeft(5) // simulate 5 seconds countdown

      const timerId = setInterval(() => {
        setTimeLeft(prev => {
          if (prev === 1) {
            clearInterval(timerId)
            return null
          }
          return prev - 1
        })
      }, 1000)

      const fileExt = newImageFile.name.split('.').pop()
      const fileName = `${Date.now()}.${fileExt}`
      const filePath = `blog/${fileName}`

      const { error: uploadError } = await supabase.storage
        .from('blog-images')
        .upload(filePath, newImageFile, { upsert: true })

      setUploading(false)
      setTimeLeft(null)

      if (uploadError) {
        alert('Failed to upload image.')
        setSaving(false)
        return
      }

      const { data: { publicUrl } } = supabase.storage
        .from('blog-images')
        .getPublicUrl(filePath)

      updatedImageUrl = publicUrl
    }

    const { error: updateError } = await supabase
      .from('posts')
      .update({
        title,
        content,
        image_url: updatedImageUrl,
      })
      .eq('id', id)

    setSaving(false)

    if (updateError) {
      alert('Failed to update post.')
      return
    }

    alert(' تم تحديث المنشور ')
    navigate(`/blogs/${id}`)
  }

  if (loading) return <p className="text-center mt-8">Loading post data...</p>

  return (
    <div className="max-w-xl mx-auto p-4 sm:p-6">
      <h1 className="text-2xl sm:text-3xl mb-5 font-semibold text-center">Edit Post</h1>

      <input
        type="text"
        className="border rounded p-2 w-full mb-4 text-base sm:text-lg"
        placeholder="Title"
        value={title}
        onChange={e => setTitle(e.target.value)}
      />

      <textarea
        rows={8}
        className="border rounded p-2 w-full mb-4 text-base sm:text-lg resize-y"
        placeholder="Content"
        value={content}
        onChange={e => setContent(e.target.value)}
      />

      {imageUrl && (
        <img
          src={imageUrl}
          alt="Post preview"
          className="mb-4 w-full max-h-64 object-contain rounded shadow"
        />
      )}

      <input
        type="file"
        accept="image/*"
        onChange={handleFileChange}
        className="mb-2 w-full"
        disabled={uploading || saving}
      />

      {uploading && (
        <p className="mb-4 text-center text-sm text-gray-600">
          Uploading image... {timeLeft ? `About ${timeLeft} second${timeLeft > 1 ? 's' : ''} remaining` : ''}
        </p>
      )}

      <button
        onClick={handleSave}
        disabled={saving || uploading}
        className={`w-full py-2 rounded text-white font-semibold transition
          ${saving || uploading ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'}`}
      >
        {saving ? 'حفظ...' : 'حفظ التغيرات  '}
      </button>
    </div>
  )
}
